/* Preview integration: Shopify's native rules, not this script, enforce the discount. */
(() => {
  const node = document.querySelector('[data-bf-kit-rules]');
  if (!node || window.bfKitDiscounts) return;
  const cfg = JSON.parse(node.textContent);
  const eligible = new Set(cfg.eligible.map(String));
  const root = cfg.root.endsWith('/') ? cfg.root : cfg.root + '/';
  let queue = Promise.resolve();
  let checkoutPending = false;
  let quantitiesEdited = false;
  let editRevision = 0;
  let saveTimer;
  let pageQueue = Promise.resolve();
  function sequencePage(work) {
    const result = pageQueue.then(work);
    pageQueue = result.catch(() => {});
    return result;
  }
  const applications = cart => [...(cart.cart_level_discount_applications || []),
    ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
  const codes = cart => [...new Set([...applications(cart).filter(a => a.type === 'discount_code').map(a => a.title), ...(cart.discount_codes || []).filter(c => c.applicable !== false).map(c => c.code)])];
  const hasBooksy = cart => codes(cart).some(c => c.toUpperCase() === 'BOOKSY30BARBA');
  const quantity = cart => cart.items.reduce((n, item) => n + (eligible.has(String(item.variant_id)) ? item.quantity : 0), 0);
  const tierCode = cart => cfg.codes[Math.min(5, quantity(cart))] || '';
  const active = cart => cart.attributes?._bf_kit_active === '1' || codes(cart).some(c => /^BFKIT-/.test(c));
  const isGift = item => String(item.variant_id) === String(cfg.giftVariant) && (
    item.final_line_price === 0 || (item.line_level_discount_allocations || []).some(a => /^AOVAI_/.test(a.discount_application.title)) ||
    Object.entries(item.properties || {}).some(([k, v]) => /gift|aov|avada/i.test(k) && v));
  async function request(path, body) {
    const response = await fetch(root + path, body === undefined ? {headers:{Accept:'application/json'}} : {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Não foi possível conferir a condição do kit. Tente novamente.');
    return data;
  }
  async function reconcile(cart) {
    cart = cart || await request('cart.js');
    if (hasBooksy(cart)) {
      // A manually chosen Booksy offer takes precedence over a remembered kit tier.
      if (cart.attributes?._bf_kit_active === '1') cart = await request('cart/update.js', {attributes:{_bf_kit_active:''}});
      document.querySelectorAll('[data-bf-cart-discount-codes]').forEach(input => input.value = 'BOOKSY30BARBA');
      return cart;
    }
    if (!cfg.enabled || !active(cart)) return cart;
    // Remove only a promotional line identified by the app; paid units are preserved.
    for (let attempt = 0; attempt < 3; attempt++) {
      const gift = cart.items.find(isGift);
      if (!gift) break;
      cart = await request('cart/change.js', {id:gift.key, quantity:0});
    }
    if (cart.items.some(isGift)) throw new Error('O brinde conflita com a condição do kit. Remova o brinde antes de continuar.');
    const wanted = cfg.b2b ? '' : tierCode(cart);
    // Kit has exactly one product code. SavePay remains automatic and payment-dependent.
    cart = await request('cart/update.js', {discount:wanted, attributes:{_bf_kit_active:cart.item_count ? '1' : ''}});
    const allocated = applications(cart).some(a => a.title === wanted);
    if (wanted && !allocated) throw new Error('O desconto do kit ainda não está disponível. Não avance esperando a economia simulada.');
    if (cart.items.some(isGift)) throw new Error('Confira o carrinho: a condição do kit não inclui brinde.');
    document.querySelectorAll('[data-bf-cart-discount-codes]').forEach(input => input.value = wanted);
    return cart;
  }
  function sync(cart) {
    const work = queue.then(() => reconcile(cart)).then(updated => {
      document.querySelectorAll('[data-bf-cart-count]').forEach(counter => counter.textContent = updated.item_count);
      return updated;
    });
    queue = work.catch(() => {});
    return work;
  }
  async function begin() {
    if (cfg.b2b) throw new Error('A condição do kit é exclusiva do varejo.');
    const currentCart = await request('cart.js');
    if (hasBooksy(currentCart)) return sync(currentCart);
    await request('cart/update.js', {attributes:{_bf_kit_active:'1'}});
    return sync();
  }
  function readQuantities(form) {
    return [...form.querySelectorAll('[data-bf-cart-key]')].map(input => ({key:input.dataset.bfCartKey, variant:input.dataset.bfCartVariant, quantity:Number(input.value), blank:input.value.trim() === ''}));
  }
  async function applyQuantities(entries) {
    let cart = await request('cart.js');
    for (const entry of entries) {
      const qty = entry.quantity;
      if (entry.blank || !Number.isInteger(qty) || qty < 0) throw new Error('Confira a quantidade dos produtos.');
      const matches = cart.items.filter(item => String(item.variant_id) === entry.variant);
      const item = cart.items.find(item => item.key === entry.key) || (matches.length === 1 ? matches[0] : null);
      if (!item && qty === 0) continue;
      if (!item) throw new Error('O carrinho mudou. Atualize a página antes de continuar.');
      if (qty !== item.quantity) cart = await request('cart/change.js', {id:item.key, quantity:qty});
    }
  }
  async function refreshPageCart(force = false, revision = null) {
    const page = document.querySelector('[data-bf-cart-section]');
    if (!page) return;
    const response = await fetch(root + 'cart?section_id=' + encodeURIComponent(page.dataset.bfCartSection));
    if (!response.ok) throw new Error('Atualize a página para conferir seu carrinho.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const updated = html.querySelector('[data-bf-cart-section]');
    // An initial refresh must not detach a form being edited or submitted.
    if (updated && !checkoutPending && (revision === null || revision === editRevision) && (force || !quantitiesEdited)) {
      const focusedVariant = document.activeElement?.dataset?.bfCartVariant;
      page.replaceWith(updated);
      if (focusedVariant) updated.querySelector('[data-bf-cart-variant="' + CSS.escape(focusedVariant) + '"]')?.focus({preventScroll:true});
    }
  }
  function cartStatus(message, busy = false, error = false) {
    const form = document.querySelector('[data-bf-page-cart]');
    if (!form) return;
    form.setAttribute('aria-busy', String(busy));
    const status = form.querySelector('[data-bf-cart-status]');
    if (status) { status.textContent = message; status.setAttribute('role', error ? 'alert' : 'status'); }
  }
  function scheduleSave(input) {
    if (!cfg.enabled || checkoutPending || !input.closest('[data-bf-page-cart]')) return;
    quantitiesEdited = true;
    editRevision++;
    clearTimeout(saveTimer);
    cartStatus('Atualizando quantidades e desconto…', true);
    saveTimer = setTimeout(() => {
      const form = document.querySelector('[data-bf-page-cart]');
      if (!form || checkoutPending) return;
      const revision = editRevision;
      const entries = readQuantities(form);
      sequencePage(async () => {
        await applyQuantities(entries);
        await sync();
        if (revision === editRevision && !checkoutPending) {
          quantitiesEdited = false;
          await refreshPageCart(true, revision);
          if (revision === editRevision) cartStatus('Carrinho atualizado.');
        }
      }).catch(error => {
        if (revision === editRevision && !checkoutPending) cartStatus(error.message, false, true);
      });
    }, 350);
  }
  document.addEventListener('input', event => {
    if (event.target instanceof HTMLInputElement && event.target.matches('[data-bf-cart-key]')) scheduleSave(event.target);
  });
  document.addEventListener('change', event => {
    if (event.target instanceof HTMLInputElement && event.target.matches('[data-bf-cart-key]')) scheduleSave(event.target);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!cfg.enabled || !(form instanceof HTMLFormElement) || !form.querySelector('[name="checkout"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutPending) return;
    if (!form.reportValidity()) return;
    clearTimeout(saveTimer);
    checkoutPending = true;
    const button = event.submitter || form.querySelector('[name="checkout"]');
    const entries = readQuantities(form);
    if (button) button.disabled = true;
    cartStatus('Conferindo seu carrinho…', true);
    try {
      await sequencePage(async () => {
        await applyQuantities(entries);
        await sync();
        // Payment discounts are determined by Stone in the standard checkout.
        await request('cart/update.js', {attributes:{paymentDiscountCheck:'no'}});
      });
      quantitiesEdited = false;
      window.location.assign(root + 'checkout');
    } catch (error) {
      cartStatus(error.message, false, true);
      if (button) button.disabled = false;
      checkoutPending = false;
    }
  }, true);
  window.bfKitDiscounts = {sync, begin, quantity, tierCode};
  if (cfg.enabled && document.querySelector('[data-bf-cart-section]')) {
    sequencePage(async () => { await request('cart/update.js', {attributes:{paymentDiscountCheck:'no'}}); await sync(); await refreshPageCart(); }).catch(error => {
      const page = document.querySelector('[data-bf-cart-section]');
      if(page){const notice=document.createElement('p');notice.setAttribute('role','alert');notice.textContent=error.message;page.prepend(notice);}
    });
  }
})();
